<div class="bg-white">
    <h2 class="settings-header px-4 py-3 mb-2 mb-md-5">
        {{'notification_day_settings' | translate}}
        <small>- {{'notification_day_settings_desc' | translate}}</small>
    </h2>
    
    <div class="settings-sub-header w-100 p-2">
        <h3 class="col-md-8 mx-auto px-md-4">
            <i class="far fa-calendar-alt"></i> {{ 'notifications' | translate}}
            <small>{{ 'notifications_day_settings_desc' | translate}}</small>
        </h3>
    </div>

    <div class="bg-grey pt-4">
        <div class="col-md-8 mx-auto px-md-4 p-0 px-2">
            <notification-days-settings></notification-days-settings>
        </div>
    </div>
</div>